/* eslint-disable prefer-template */
import { decode } from 'base-64';

const thirtyMinutes = 60 * 30;
export const renewJwtThresholdInSec = thirtyMinutes;

export interface ParsedUserJwt {
  expires: number; // 1674838039
  uuid: string; // "8dc47b6f-aecc-4525-a374-000371b6e9e7"
  subscriptions: number[]; // [254]

  /* Do not include unused fields in type definition */

  // authentication_group_id: 0;
  // cacheId: string; // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJp...
  // clientAttributes: unknown[];
  // country: 'US';
  // created: number; // 1674834439
  // iat: number; // 1674834439
  // issued: number; // 1674834439
  // language: string[]; // ['en']
  // role_ids: number[]; //[2]
  // uid: string; // "4207896"
  // userHiddenContent: unknown[];
  // user_account_authentication_group_id: number; // 0
  // user_account_id: string; // "aeecee62-c27d-4b70-a58c-da1c9ba28ca4"
  // user_created: number; // 1672859130420
}

// @TODO remove after TS >= 4.9 devblogs.microsoft.com/typescript/announcing-typescript-4-9-beta/#in-narrowing
const hasKey = <K extends string, T extends object>(k: K, o: T): o is T & Record<K, unknown> =>
  k in o;

const isValid = (o: unknown | ParsedUserJwt): o is ParsedUserJwt => {
  if (typeof o !== 'object' || o === null) return false;
  if (!hasKey('subscriptions', o) || !Array.isArray(o.subscriptions)) return false;
  if (!hasKey('uuid', o) || typeof o.uuid !== 'string') return false;
  if (!hasKey('expires', o) || typeof o.expires !== 'number') return false;
  return true;
};

export const parseUserJwt = (jwt: string): ParsedUserJwt => {
  const base64Url = jwt.split('.')[1];
  if (!base64Url) throw new Error('Invalid token string');
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    decode(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );

  const parsedJwt = JSON.parse(jsonPayload);
  if (!isValid(parsedJwt)) throw new Error('Invalid token shape');
  return parsedJwt;
};

export const shouldRenew = (jwt: ParsedUserJwt | string) => {
  const parsedJwt = typeof jwt === 'string' ? parseUserJwt(jwt) : jwt;
  const nowInSec = Math.floor(Date.now() / 1000);
  return nowInSec + renewJwtThresholdInSec > parsedJwt.expires;
};
